import Item from './item'
import ItemView from './view'
import { createDict } from '@/util/dicts'
import { duration } from '@/util'
import global from '@/util/mixin/global'
import Review from './partial/review'
// import ExportBox from '@/views/common/partial/export-verify'
import listComponent from '@/util/proto/listComponent'
import { saveFile, saveJSON } from '@/util'
import LicenseSelect from '../partial/license-select'

//0、申请中，1、待开始考试，2、考试中，3，考试完成（待发放），4、申请不通过，5、驾照已经发放，6、待申请
const stateIcon = [
  { value: 0, label: 'warning' },
  { value: 1, label: 'warning' },
  { value: 2, label: 'processing' },
  { value: 3, label: '#2d8cf0' },
  { value: 4, label: 'error' },
  { value: 5, label: 'success' },
  { value: 6, label: 'warning' },
]

export default {
  extends: listComponent,
  mixins:[global],
  data() {
    let cols = []

    return {
      columns: [
        {
          title: '姓名',
          key: 'name',
          render:(h,{row}) => {
            return (
              <div style="display: flex; align-items: center;">
                <sl-badge title={row.stateText} style={{'marginRight':'12px'}} status={row.stateIcon} />
                <div style="flex: 1 1 auto;">
                  <div class="tb-list-item-cell">
                    <div class="tb-list-item-cell-l">
                      <span style="font-size:14px;color: rgba(0, 0, 0, 0.65);">{row.name}</span>
                      <span style="font-size:11px;color:rgba(0,0,0,.55);margin-left:8px;">
                        <Icon custom="i-icon icon-credentials" />
                        {row.idcard}
                      </span>
                      <span style="font-size:11px;color:rgba(0,0,0,.55);margin-left:8px;">
                        <Icon style={{'marginRight':'5px'}} type="md-phone-portrait" />
                        <span>{row.phone}</span>
                      </span>
                    </div>

                    <div class="tb-list-item-cell-r">
                        <span style="font-size:12px;color:rgba(0,0,0,.6);">
                          <span>{row.stateText}</span>
                        </span>
                    </div>
                  </div>
                  <div class="tb-list-item-cell">
                    <div class="tb-list-item-cell-l light" style="font-size:12px;">{row.companyName}</div>
                    <div class="tb-list-item-cell-r">
                      <span title="身份证">{row.licenseName}</span>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 185,
          align: 'center',
          render: (h, {row}) => {
            let acts = []
            if(this.$a('courier.list.detail')){
              acts.push(<a on-click={()=>this.view(row)}>查看</a>)
            }

            if(row.state == 0){
              acts.push(<a on-click={()=>this.review(row)}>审核</a>)
            }

            if(row.state == 3){
              acts.push(<a on-click={()=>this.release(row)}>发放</a>)
            }

            return this.$utils.link(acts, <Divider type="vertical" />)
          }
        }
      ],
      data: [],
      params: {
        name: null,
        phone: null,
        companyName: null,
        licenseId: null,
        idcard:null,
        state:null,
        districtCode: null
      },
      loading: false,
      exportLoading:false,
    }
  },

  computed: {
    removeDisable() {
      return this.selection.length == 0
    },
    searchLabel() {
      return this.visibleSearchBox ? '收起' : '高级搜索'
    },
    importUrl() {
      return this.$request.courierImportUrl()
    }
  },
  watch: {
    $route(to, from) {
      this.search()
    }
  },
  created() {
    this.def = { ...this.params }
    if(this.isAdmin){
      this.columns.unshift({
        type: 'selection',
        width: 45,
        align: 'center'
      })
    }

    this.search()
  },

  methods: {

    search() {
      let params = { search: { ...this.params,isLast:1 }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      //TODO 
      //if(this.$store.state.auth.userRole == 1){
        //params.search['province'] = this.$store.state.auth.user.orgVO.province
        // params.search['city'] = this.$store.state.auth.user.orgVO.city
        // params.search['area'] = this.$store.state.auth.user.orgVO.area
      //}
      this.$request.licenseExamRecords(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.flat(this.$utils.conv(resp.data.list || [], { 'createDatetime': 'datetime', 'status': '$enable', 'gender': '$gender','politic':'politic','state':'examState','state:stateIcon':stateIcon}))
          this.page.total = resp.data.total || 0
        }
      })
    },

    view(row) {
      this.$refs['itemView'].init(row.id, this.type)
    },
    // edit(row) {
    //   this.modalVisible = true
    //   this.$refs['item'].init(row.id, this.type)
    // },

    // create() {
    //   this.modalVisible = true
    //   this.$refs['item'].init(0, this.type)
    // },

    remove(row) {
      this.$ui.confirm(this.$request.courierDelete, `确定删除 ${row.name} ？`)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.selection = []
          this.search()
        }
      })
    },
    release(row){
      this.$ui.confirm(this.$request.licenseExamRecordRelease, `确认为${row.name}发放上岗证 ？`)(row.id).then(resp => {
        if (resp.code == 0) {
          this.$Message.success('操作成功')
          this.search()
        }else{
          this.$Message.error(resp.msg)
        }
      })
    },
    releaseBatch(selection){
      this.$ui.confirm(this.$request.licenseExamRecordReleaseBatch, `确认为${selection.map( i => i.name).join('、')}，共${selection.length}人发放上岗证 ？`)(selection.map(i => i.id)).then(resp => {
        if (resp.code == 0) {
          this.$Message.success(resp.data || '操作成功')
          this.search()
        }else{
          this.$Message.error(resp.msg)
        }
      }).catch(() => {})
    },
    reset() {
      this.params = {}
      this.search()
    },

    toggle(row) {
      let tips = row.status == 1 ? '启用' : '禁用'
      this.$ui.confirm(this.$request.courierToggle, `确定${tips} ${row.name} ？`)(row.id, row.status ? 0 : 1).then(resp => {
        if (resp.code) {
          this.$Message.error(resp.msg)
        } else {
          this.$Message.success('操作成功')
          this.selection = []
          this.search()
        }
      })

    },

    review(row){
      this.$refs['itemView'].init(row.id, true)
    },

    handleExport(ids){
      let search = { ...this.params }
      if( ids && ids.length > 0 ){
        search = { ids }
      }

      let params = { search }

      this.$sms({title: '导出','api':'licenseExamRecordExport' , params })
      
    },
  },
  render(){
    const tableScopedSlots = this.isAdmin ? {
      batch:({selection , enable}) => {
        const acts = []
        if( this.$a('license.exam.release') ){
          let validData = selection.filter( i => i.state == 3)
          let disabled = validData.length == 0
          acts.push(<Button disabled={disabled} loading={this.exportLoading} style="margin-left:8px;" type="primary" custom="i-icon icon-drive-license" on-click={()=>this.releaseBatch(validData)}>批量发放</Button>)
        }
        return acts
        
      }
    } : {}
    return (
      <sl-page>
        <div class="page-filter">
          <sl-search on-search={this.search} on-reset={this.reset}showCount={4} >
            <sl-search-item label="">
              <i-input v-model={this.params.name} placeholder="姓名" />
            </sl-search-item>
            <sl-search-item label="">
              <i-input v-model={this.params.phone} placeholder="电话" />
            </sl-search-item>
            <sl-search-item label="">
              <sl-select v-model={this.params.state} dict="examState" placeholder="考试状态" />
            </sl-search-item>
            <sl-search-item label="">
              <i-input v-model={this.params.companyName} placeholder="企业名称" />
            </sl-search-item>
            <sl-search-item label="">
              <i-input v-model={this.params.idcard} placeholder="身份证号码" />
            </sl-search-item>
            <sl-search-item label="">
              <LicenseSelect multiple={false} v-model={this.params.licenseId} placeholder="证照类型" />
            </sl-search-item>
            <sl-search-item label="">
              <sl-area v-model={this.params.districtCode} data-type="code" placeholder="所在区域" />
            </sl-search-item>
          </sl-search>
        </div>

        <div class="pg-bd">
          <sl-table showHeader={false} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange} selectionKey={false} scopedSlots={tableScopedSlots}>
          </sl-table>
        </div>
        <Item ref="item" on-update={this.search} />
        <ItemView ref="itemView" />
      </sl-page>
    )
  }
}
